export default __webpack_public_path__ + "static/media/buyNow.24636535.jpg";